import React from 'react'

import { FormTitleProps } from '../items/FormTitle'
import SelectLinkLine, { SelectLinkLineProps } from '../items/SelectLinkLine'
import BaseGroup from './BaseGroup'

// TODO Groupをつける

/**
 * 選択リンクグループ
 */
const SelectLink: React.FC<SelectLinkProps> = (props) => {
  return (
    <BaseGroup
      isRequired={props.isRequired}
      title={props.title}
      description={props.description}
      hideTitle={props.hideTitle}
    >
      <SelectLinkLine
        forwardTo={props.forwardTo}
        lineLabel={props.lineLabel}
        arrowLabel={props.arrowLabel}
      />
    </BaseGroup>
  )
}

export type SelectLinkProps = FormTitleProps & SelectLinkLineProps

export default React.memo<SelectLinkProps>(SelectLink)
